export const CPF_LENGTH = 11;
export const CNPJ_LENGTH = 14;

export function cleanDocument(value: string): string {
  return value.toUpperCase().replace(/[^0-9A-Z]/g, "");
}

export function cleanCpf(value: string): string {
  return value.replace(/\D/g, "");
}

export function normalizeDocumentInput(value: string, isCnpj: boolean): string {
  return isCnpj
    ? cleanDocument(value).slice(0, CNPJ_LENGTH)
    : cleanCpf(value).slice(0, CPF_LENGTH);
}
